module.exports = __webpack_public_path__ + "static/hero-large-enterprise-0dcf93615dfd9049d91a266e0e50d9f8.svg";